import script from "./ImageCropper.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageCropper.vue?vue&type=script&setup=true&lang=ts"

import "./ImageCropper.vue?vue&type=style&index=0&id=30b1f5f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b1f5f5"]])

export default __exports__